'use strict';

import controller from './domicilio.controller';
import template from './domicilio.html';

const DomicilioComponent = {
    bindings: {},
    controller,
    template
};

export default DomicilioComponent;


// WEBPACK FOOTER //
// ./src/app/components/admin/login/domicilio/domicilio.component.js